// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.

const burger = document.querySelector(".hamburger");
const navbar = document.querySelector(".navbar");
const navLink = document.querySelectorAll(".menu-item");
const mainHeader = document.querySelector(".main-header");
const symbol = document.getElementById("symbol");
const logo = document.getElementById("logo");

const coverBorder = document.querySelector(".cover-border");
const coverTitle = document.querySelector(".cover-title");

const hamburger = document.getElementById("hamburger");

burger.addEventListener("click", () => {
  navbar.classList.toggle("nav-open");
  burger.classList.toggle("is-active");
  mainHeader.classList.toggle("nav-open");
  navLink.forEach((link) => {
    link.classList.toggle("nav-link-open");
  });
});

window.addEventListener("scroll", () => {
  if (window.scrollY >= 550) {
    mainHeader.classList.add("on-scroll");
    symbol.classList.add("logo-on-scroll");
    hamburger.classList.add("on-scroll");
  } else if (window.scrollY <= 550) {
    mainHeader.classList.remove("on-scroll");
    symbol.classList.remove("logo-on-scroll");
    hamburger.classList.remove("on-scroll");
  }
});

window.addEventListener("scroll", () => {
  if (window.scrollY >= 50) {
    logo.classList.add("hide");
  } else if (window.scrollY <= 50) {
    logo.classList.remove("hide");
  }
});

window.addEventListener("scroll", () => {
  if (window.scrollY >= 50) {
    coverBorder.style.width = "0px";
    coverTitle.style.color = "#ECF3F2";
  } else if (window.scrollY <= 50) {
    coverBorder.style.width = "100%";
    coverTitle.style.color = "#fff";
  }
});
///

// Hide Header on on scroll down

const body = document.body;
const scrollUp = "scroll-up";
const scrollDown = "scroll-down";
let lastScroll = 0;

window.addEventListener("scroll", () => {
  const currentScroll = window.pageYOffset;
  if (currentScroll <= 850) {
    body.classList.remove(scrollUp);
    return;
  }

  if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
    // down
    body.classList.remove(scrollUp);
    body.classList.add(scrollDown);
  } else if (
    currentScroll < lastScroll &&
    body.classList.contains(scrollDown)
  ) {
    // up
    body.classList.remove(scrollDown);
    body.classList.add(scrollUp);
  }
  lastScroll = currentScroll;
});

/* const scrollBtn = document.querySelector(".scroll-to-top");

const btnVisibility = () => {
  if (window.scrollY > 800) {
    scrollBtn.style.backgroundColor = "tomato";
  } else {
    scrollBtn.style.backgroundColor = "yellow";
  }
};

scrollBtn.addEventListener("click", () => {
  window.scrollTo({
    top: 0,
  });
});

document.addEventListener("scroll", () => {
  btnVisibility();
});
 */

/// Creating momentum scroll

/* const bodywrapper = document.body;
const main = document.getElementById("scroll-container");

let sx = 0, // For scroll positions
  sy = 0;
let dx = sx, // For container positions
  dy = sy;

bodywrapper.style.height = main.clientHeight + "px";

main.style.position = "fixed";
main.style.top = 0;
main.style.left = 0;

// Bind a scroll function
window.addEventListener("scroll", easeScroll);

function easeScroll() {
  sx = window.pageXOffset;
  sy = window.pageYOffset;
}

window.requestAnimationFrame(render);

function render() {
  //We calculate our container position by linear interpolation method
  dx = li(dx, sx, 0.2);
  dy = li(dy, sy, 0.2);

  dx = Math.floor(dx * 100) / 100;
  dy = Math.floor(dy * 100) / 100;

  main.style.transform = `translate3d(-${dx}px, -${dy}px, 0px)`;

  window.requestAnimationFrame(render);
}

function li(a, b, n) {
  return (1 - n) * a + n * b;
}
 */



// WEBPACK FOOTER //
// ./resources/assets/js/app.js